type AwsStage = 'dev' | 'int' | 'prod'
type S2aAwsStage = 'dev' | 'test' | 'prod'

export function getAwsStage(): AwsStage {
    switch (import.meta.env.VITE_STAGE) {
        case 'prod':
            return 'prod'
        case 'test':
            return 'int'
        case 'dev':
        case 'local':
            return 'dev'
        default:
            throw new Error(`Unknown stage: ${import.meta.env.VITE_STAGE satisfies never}`)
    }
}

export function getS2aAwsStage(): S2aAwsStage {
    switch (import.meta.env.VITE_STAGE) {
        case 'prod':
            return 'prod'
        case 'test':
            return 'test'
        case 'dev':
        case 'local':
            return 'dev'
        default:
            throw new Error(`Unknown stage: ${import.meta.env.VITE_STAGE satisfies never}`)
    }
}
